module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "list"
  }, [_c('header', [_c('span', [_vm._v("共有" + _vm._s(_vm.commentData.totalCount) + "条评价")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": _vm.uploadComment
    }
  }, [_vm._v("下载评价")])]), _vm._v(" "), _c('section', {
    staticClass: "comment"
  }, _vm._l((_vm.commentData.data), function(item, index) {
    return _c('content-component', {
      key: item.id,
      attrs: {
        "info": item
      }
    })
  })), _vm._v(" "), _c('v-pagination', {
    attrs: {
      "current": _vm.currentPage,
      "total": Math.ceil(_vm.commentData.totalCount / 20),
      "size": 'md',
      "first": false,
      "last": false
    },
    on: {
      "current-change": function($event) {
        _vm.currentChangeFunc($event)
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7038d320","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/comment/list/components/list/List.vue
// module id = 724
// module chunks = 0